export default __webpack_public_path__ + "2a7616ff50ff6aa65bfde0f98f354987.png";